import { checkType, CtyShowToast } from "@circuitry-ai/doc-ui";

export type ItemType = 'users' | 'permissions' | 'groups';

// Constants
export const TYPE_CONFIG = {
  users: { 
    color: 'blue', 
    icon: 'mdi:account', 
    bgColor: 'bg-primary/10', 
    textColor: 'text-primary', 
    hoverColor: 'text-primary hover:text-primary' 
  },
  permissions: { 
    color: 'green', 
    icon: 'mdi:shield-key', 
    bgColor: 'bg-success/10', 
    textColor: 'text-success', 
    hoverColor: 'text-success hover:text-success' 
  },
  groups: { 
    color: 'purple', 
    icon: 'mdi:account-group', 
    bgColor: 'bg-purple-100', 
    textColor: 'text-purple-800', 
    hoverColor: 'text-purple-600 hover:text-purple-800' 
  }
} as const;

// Generic cell renderer - moved to separate component files
export const getCellContent = (type: ItemType, data: any, field: string) => {
  switch (type) {
    case 'users': 
      return { 
        initial: (data.email || data.name || 'U').charAt(0).toUpperCase(), 
        text: data.name || data.email, 
        bgColor: 'bg-primary/10', 
        textColor: 'text-primary' 
      };
    case 'permissions':
      {
        let text;
        if (field === 'resource') {
          text = data.resource.includes('/') ? data.resource.split('/')[1] : data.resource;
        } else {
          text = data.relation;
        }
        return { 
          icon: 'mdi:shield-key', 
          text, 
          bgColor: 'bg-success/10', 
          textColor: 'text-success' 
        };
      }
    case 'groups': 
      return { 
        icon: 'mdi:account-group', 
        text: data.group, 
        bgColor: 'bg-purple-100', 
        textColor: 'text-purple-600' 
      };
    default: 
      return { text: data[field] };
  }
};

export const getRelationBadgeClass = (relation: string) => {
  const badgeClasses = { 
    admin: 'bg-danger/10 text-danger', 
    editor: 'bg-primary/10 text-primary', 
    executor: 'bg-purple-100 text-purple-800' 
  } as const;
  return badgeClasses[relation as keyof typeof badgeClasses] || 'bg-default-100 text-default-700';
};

// Error handling
export const handleApiError = (error: any, message?: string) => {
  console.error('API Error:', error);
  const errorMessage = error?.data?.message || error?.message || message || 'An error occurred';
  CtyShowToast(checkType.error, errorMessage);
};

export const handleApiSuccess = (message: string) => {
  CtyShowToast(checkType.success, message);
};
